import React from 'react';

function TooltipCustom({
  name, style, children, className, ...props
}) {
  return (
    <div className={`${className ? className : 'tooltipCustom'} `} style={style}>
      {children}
      <span className="tooltipTextCustom">{name}</span>
    </div>
  );
}

export default TooltipCustom;
